import HttpService from "~/Scripts/services/httpService";

const instance = new HttpService( "umbraco/api/LmToolkitApi/" );

/* eslint-disable arrow-body-style */
/* eslint-disable object-shorthand */

/**
 * Gets the available tools from the database
 */
export const getTools = () => {
  return instance.get( "GetTools" );
};

/*
 * Gets the content pages for the tools and maps their URL with their respective ID
 */
export const getToolLinks = () => {
  return instance.get( "GetToolLinks" );
};

/*
 * Logs a user's website usage details
 */
export const addUserUsage = ( title, detail ) => {
  return instance.post( "AddUserUsage", null, { title, detail } );
};
